import { Flex, Loader } from '@fluentui/react-northstar';

// Utils
import { ILoader } from 'UTILS/teamsInterface';

// renders a full Screen loader with lable in center of the page
const FullScreenLoader = ({ label }: ILoader) => {
  return (
    <Flex fill hAlign="center" vAlign="center">
      <Loader label={label} />
    </Flex>
  );
};

export default FullScreenLoader;
